import React, { useEffect } from "react";
import { navigate } from "gatsby";

const GlosarioArticulosRedirect = () => {
    useEffect(() => {
        navigate("/balanz-academy/glosario-financiero/articulos/", { replace: true });
    }, []);

    return null;
};

export const Head = () => (
    <>
        <meta httpEquiv="refresh" content="0; url=/balanz-academy/glosario-financiero/articulos/" />
        <link rel="canonical" href="/balanz-academy/glosario-financiero/articulos/" />
        <meta name="robots" content="noindex" />
    </>
);

export default GlosarioArticulosRedirect;
